import { render, staticRenderFns } from "./OnePOneVStUpper.vue?vue&type=template&id=b6c9cace"
import script from "./OnePOneVStUpper.vue?vue&type=script&lang=js"
export * from "./OnePOneVStUpper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports